import { configureStore } from '@reduxjs/toolkit';
import { authCombinedReducer } from '@origo/auth';
import { mapSlice } from '@origo/map-context';

const store = configureStore({
    reducer: {
        auth: authCombinedReducer,
        // Map-context bruker Redux for hover/klikk-tilstand i kartet.
        // Map-komponenten i `@origo/map-context` leser via selectors mot
        // `state.map`, så slice-en MÅ registreres når <Map /> brukes.
        map: mapSlice.reducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
